export async function fetchDataFromApi(url: string) {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error("API request failed");
        }
        return await response.json();
    } catch (error) {
        console.error(error);
        return null
    }
}

export async function fetchComponentData(url: string, key: string, ttlInSeconds: number) {
    const currentTime = Math.floor(Date.now() / 1000);

    if (ttlInSeconds === 0) {
        return await fetchDataFromApi(url);
    }

    const cachedData = localStorage.getItem(key);

    if (cachedData) {
        const { data, expiration } = JSON.parse(cachedData);

        if (currentTime < expiration) {
            return data; // Data is still valid, return cached data
        }
    }

    const newData = await fetchDataFromApi(url);

    if(newData){
        // Cache the new data with a new expiration timestamp
        const newExpiration = currentTime + ttlInSeconds;
        const newDataObj = { data: newData, expiration: newExpiration };
        localStorage.setItem(key, JSON.stringify(newDataObj));
        
    }else{
        if (cachedData) {
            return JSON.parse(cachedData).data; // Use cached data on API fetch error
        }
    } 
    
    return newData;
}